import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import theme from '../../styles/theme';
import TermsApi from './terms-api';
import GameChooser from '../game-chooser/gameChooser';
import SinglePlayerGame from '../singleplayer-game/singlePlayerGame';
import EliminationMode from '../elimination-mode/eliminationMode';
import ContentSwapper from '../content-swapper/contentSwapper';

import './packSession.css';

export default class PackSession extends Component {

  constructor(props) {
    super(props);
    
    this.termsApi = new TermsApi();
    this.beginGame = this.beginGame.bind(this);
    this.gameEnded = this.gameEnded.bind(this);

    this.gameModes = {
      classic: 'classic', 
      timed: 'timed', 
      elimination: 'elimination'
    }

    this.state = { gameMode: null };
  }

  componentDidMount() {
    setTimeout(() => {
      this.termsApi.fetchTermsForPack(this.props.pack).then(terms => {
        this.setState({ terms: terms });
      }).catch(error => {
        console.log('Error fetching and parsing data', error);
      });
    }, 1000);
  }

  componentWillUnmount() {
    this.termsApi.terminateRequest();
  }

  beginGame(mode) {
    return this.setState({ gameMode: mode });
  }

  gameEnded() {
    this.setState({ gameMode: null });
  }

  renderGame(gameMode) {
    if (gameMode === this.gameModes.classic || gameMode === this.gameModes.timed) {
      return (<SinglePlayerGame 
        pack={this.props.pack} 
        terms={this.state.terms} 
        onQuitGame={this.gameEnded} 
        highScore={this.state.highScore}
        gameMode={gameMode} />);
    }

    if (gameMode === this.gameModes.elimination) {
      return (<EliminationMode 
        pack={this.props.pack} 
        onQuitGame={this.gameEnded} 
        timeLimitSeconds={10} />);
    }

    return null;
  }

  render() {
    return (
      <div className='pack-session'>
        <ThemeProvider theme={theme}>
          <ContentSwapper swap={this.state.gameMode !== null}>
            <GameChooser 
              gameModes={this.gameModes} 
              termsLoaded={this.state.terms !== undefined} 
              beginGameHandler={this.beginGame} />
            {this.renderGame(this.state.gameMode)}            
          </ContentSwapper>
        </ThemeProvider>
      </div>
    );
  }
}

PackSession.propTypes = {
  pack: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/components/pack-session/packSession.js